var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 14.5488,
    cy: 14.2148,
    r: 14,
    fill: "#D51A52"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4164_32825)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7623 10.0127C16.4336 7.68392 12.6603 7.68017 10.3361 10.0044C8.01032 12.3309 8.01257 16.1027 10.3428 18.4314C12.6716 20.7602 16.4456 20.7632 18.7691 18.4389C21.0941 16.1147 21.0918 12.3414 18.7623 10.0127ZM15.7601 16.7282L14.4941 15.4622L13.2281 16.7282C12.7113 17.2449 12.3228 17.6949 11.7063 17.0792C11.0913 16.4634 11.5391 16.0749 12.0581 15.5574L13.3241 14.2922L12.0581 13.0262C11.5406 12.5094 11.0913 12.1209 11.7063 11.5044C12.3228 10.8894 12.7113 11.3387 13.2281 11.8562L14.4941 13.1207L15.7601 11.8562C16.2776 11.3394 16.6638 10.8887 17.2803 11.5044C17.8968 12.1209 17.4476 12.5094 16.9301 13.0262L15.6641 14.2914L16.9301 15.5567C17.4468 16.0749 17.8968 16.4634 17.2803 17.0792C16.6653 17.6949 16.2776 17.2449 15.7601 16.7282Z",
    fill: "#D51A52"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4164_32825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(8.54883 8.21484)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/Error-Icon.239e809ea38fe219928a4b59cf373bc1.svg";
export { ForwardRef as ReactComponent };